import type { HTMLProps } from "react";

import * as styles from "./FormWrapper.styles";

const FormWrapper = (props: HTMLProps<HTMLDivElement>) => {
  return <div css={styles.wrapper} {...props} />;
};

export { FormWrapper };
